<template>
  <b-row class="m-0">
    <b-col cols="12" md="12" class="px-0">
      <FileDragging
        :label="label"
        :generateValidationText="generateValidationText"
        :errorMessage="errorMessage"
        :files="files"
        :multiple="multiple"
        :hasEditTitle="hasEditTitle"
        :attachmentTypeOptions="attachmentTypeOptions"
        :selectedAttachmentType="!!attachmentType"
        :maxCountUpload="maxCountUpload"
        :loading="uploaderLoading"
        @remove="remove"
        @onChange="onChange"
        @changeAttachmentType="changeAttachmentType"
        @changeCaption="changeTempFileCaption"
      />
      <Modal
        :show="isCropperModal"
        :title="$lang.crop_image"
        :hasClose="false"
        size="sm"
        contentClass="height--max-content"
        @close="handleCloseCropperModal"
      >
        <template #body>
          <Cropper
            ref="cropComponent"
            :file="pathOr(null, ['0', 'data'], files)"
            :aspectRatio="aspectRatio"
            :initialAspectRatio="aspectRatio"
            @clearValue="reset"
            @submit="createFile"
          />
        </template>
      </Modal>
    </b-col>
  </b-row>
</template>

<script>
import uploaderMixin from "@/mixin/uploaderMixin.vue";
import { Modal } from "@/components/re-design";
import FileDragging from "./FileDragging.vue";
import Cropper from "@/components/re-design/cropper/Cropper.vue";
import { v4 as uuid } from "uuid";
import { pathOr } from "ramda";
import { attachmentTemp } from "@/services";

export default {
  mixins: [uploaderMixin],
  components: { FileDragging, Modal, Cropper },
  props: {
    currentFiles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tempFiles: [],
    };
  },
  methods: {
    pathOr,
    reset() {
      this.files = [];
      this.tempFiles = [];
      this.errorMessage = "";
      this.$emit("getFiles", this.tempFiles);
    },
    remove(removeCode) {
      // remove item of original files
      const fileIndex = this.files.findIndex(
        ({ clientCode }) => clientCode === removeCode
      );
      if (fileIndex !== -1) {
        this.files.splice(fileIndex, 1);
      }

      // remove item of temp files
      const tempFileIndex = this.tempFiles.findIndex(
        ({ clientCode }) => clientCode === removeCode
      );
      if (tempFileIndex !== -1) {
        this.tempFiles.splice(tempFileIndex, 1);
      }

      this.errorMessage = "";
      this.$emit("remove", removeCode);
      this.$emit("getFiles", this.tempFiles);
    },
    createFile(image) {
      // this.file = this.hasCrop ? image : file;
    },
    async onChange(files) {
      this.errorMessage = "";

      // check limit of max upload count size of current uploaded files
      const limitedMaxCountUploadOldFiles =
        this.currentFiles.filter((fileItem) => {
          const oldFileAttachmentId = pathOr(
            null,
            ["attachmentType", "id"],
            fileItem
          );
          const currentFileAttachmentId = pathOr(
            null,
            ["id"],
            this.attachmentType
          );
          return oldFileAttachmentId === currentFileAttachmentId;
        }).length >= this.maxCountUpload;

      // check limit of max upload count size of new uploading files
      const limitedMaxCountUploadNewFiles =
        this.files.length >= this.maxCountUpload;

      for (const file of files) {
        if (limitedMaxCountUploadOldFiles || limitedMaxCountUploadNewFiles) {
          const message = `در این بخش حداکثر ${this.maxCountUpload} فایل را می‌توانید بارگزاری کنید`;
          return this.$notify.warning(message);
        }
        const isValid = this.checkValidFile(file);
        if (!isValid) {
          this.errorMessage = this.$lang.invalid_file_message;
          return;
        }
        if (this.hasCrop && !this.multiple && this.isImage(file)) {
          this.$refs.cropComponent.showModal();
        }
        const fileData = {
          progressWidth: 1,
          caption: file.name,
          clientCode: uuid(),
          attachmentTypeCaption: pathOr("", ["caption"], this.attachmentType),
          data: file,
        };
        this.files.push(fileData);
        this.upload(fileData);
      }
    },
    async upload(file) {
      if (!file) return;

      try {
        const progress = {
          onUploadProgress: function (e) {
            file.progressWidth = parseInt(
              Math.round((e.loaded * 100) / e.total)
            );
          }.bind(this),
        };
        const response = await attachmentTemp(file.data, progress);
        const { code } = response;
        file.code = code;
        const { clientCode } = file;
        const newFile = {
          clientCode,
          code,
          attachment_type_name: this.attachmentTypeName,
          attachment_type_id: pathOr(null, ["id"], this.attachmentType),
          caption: file.caption,
        };
        this.tempFiles.push(newFile);
        this.$emit("getFiles", this.tempFiles);
      } catch (error) {
        this.files = this.files.filter(
          ({ clientCode }) => clientCode !== file.clientCode
        );
        const errorMessage = pathOr("", ["response", "data", "message"], error);
        this.errorMessage = Array.isArray(errorMessage)
          ? errorMessage.join()
          : errorMessage;
      } finally {
        file.progressWidth = 0;
      }
    },
    changeTempFileCaption(file) {
      // edit caption of temp files
      this.tempFiles = this.tempFiles.map((item) => {
        const caption = item.code === file.code ? file.caption : item.caption;
        return {
          ...item,
          caption,
        };
      });
      this.$emit("getFiles", this.tempFiles);
    },
  },
};
</script>
